import { Link } from 'react-router-dom';
import './KitchenFittersPage.css';

const COLLECT = [
  {
    title: 'Sinks & Taps',
    image: '/images/kitchen-fitters/kitchen-sinks-taps.png',
  },
  {
    title: 'Appliance Parts',
    image: '/images/kitchen-fitters/kitchen-appliance-parts.png',
  },
  {
    title: 'Metal Worktops & Edging',
    image: '/images/kitchen-fitters/kitchen-worktops.png',
  },
  {
    title: 'Metal Shelving & Offcuts',
    image: '/images/kitchen-fitters/kitchen-shelving.png',
  },
  {
    title: 'Drawer Runners & Hinges',
    image: '/images/kitchen-fitters/kitchen-runners-hinges.png',
  },
  {
    title: 'Metal Offcuts & Fittings',
    image: '/images/kitchen-fitters/kitchen-offcuts.png',
  },
];

const STEPS = [
  {
    n: '1',
    title: 'Post your scrap',
    body: 'Add a few photos, your postcode and what needs clearing from the fit-out.',
  },
  {
    n: '2',
    title: 'We find collectors',
    body: 'Nearby licensed collectors review your listing and offer a collection window.',
  },
  {
    n: '3',
    title: 'Collector confirms',
    body: 'Agree access notes, parking and timing so the pickup runs smoothly on site.',
  },
  {
    n: '4',
    title: 'Scrap is collected',
    body: 'Metal is cleared from the job and moved through licensed handling routes.',
  },
  {
    n: '5',
    title: 'You get more done',
    body: 'Your crew stays focused on the install while the leftovers leave the site.',
  },
];

const REASONS = [
  {
    title: 'Licensed & verified collectors',
    body: 'Matched collectors are verified scrap carriers — not random van ads.',
  },
  {
    title: 'Compliant & safe',
    body: 'Responsible routes help you keep site clearances tidy and accountable.',
  },
  {
    title: 'Cost effective',
    body: 'Post for free and avoid losing a day running metal to the tip yourself.',
  },
  {
    title: 'Better for the environment',
    body: 'Metals are recovered for reuse instead of sitting in mixed waste streams.',
  },
  {
    title: 'Built for busy fit-outs',
    body: 'Share access notes and photos so collectors arrive ready for kitchen jobs.',
  },
];

const TRUST = [
  { label: 'Save time', detail: 'Clear site leftovers fast' },
  { label: 'Save money', detail: 'Free to post online' },
  { label: 'Recycle more', detail: 'Metal recovered properly' },
  { label: 'Stay compliant', detail: 'Licensed collectors only' },
];

export default function KitchenFittersPage() {
  return (
    <div className="kf-page">
      <section className="kf-hero" aria-labelledby="kf-hero-heading">
        <div className="kf-hero-inner">
          <div className="kf-hero-copy">
            <p className="kf-kicker">SnapScrap for trade</p>
            <h1 id="kf-hero-heading">
              Scrap collection for <span>kitchen fitters</span>
            </h1>
            <p className="kf-lead">
              Get rid of unwanted metal, appliances and fit-out offcuts quickly and responsibly —
              so your next kitchen install stays clean, safe and on schedule.
            </p>

            <div className="kf-hero-actions">
              <Link className="kf-btn" to="/post-scrap">
                Post scrap free →
              </Link>
              <Link className="kf-btn kf-btn-ghost" to="/how-it-works">
                See how it works
              </Link>
            </div>

            <ul className="kf-trust">
              {TRUST.map((item) => (
                <li key={item.label}>
                  <strong>{item.label}</strong>
                  <span>{item.detail}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="kf-hero-media">
            <img
              src="/images/businesses/biz-kitchen-fitters.png"
              alt="Kitchen fitting scrap ready for collection"
            />
            <p className="kf-hero-note">Built for fit-out crews — sinks, appliances, runners and offcuts</p>
          </div>
        </div>
      </section>

      <section className="kf-section" aria-labelledby="kf-collect-heading">
        <div className="kf-inner">
          <header className="kf-header">
            <h2 id="kf-collect-heading">What scrap we collect</h2>
            <p>Typical metal leftovers from kitchen installs, strip-outs and replacements</p>
          </header>

          <ul className="kf-collect-grid">
            {COLLECT.map((item) => (
              <li key={item.title}>
                <div className="kf-collect-image">
                  <img src={item.image} alt="" loading="lazy" />
                </div>
                <h3>{item.title}</h3>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="kf-section kf-section-tint" aria-labelledby="kf-steps-heading">
        <div className="kf-inner">
          <header className="kf-header">
            <h2 id="kf-steps-heading">How SnapScrap works</h2>
            <p>Five simple steps from posting leftovers to a clear install site</p>
          </header>

          <ol className="kf-steps">
            {STEPS.map((step) => (
              <li key={step.n}>
                <span className="kf-step-n" aria-hidden="true">
                  {step.n}
                </span>
                <h3>{step.title}</h3>
                <p>{step.body}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section className="kf-section" aria-labelledby="kf-why-heading">
        <div className="kf-inner">
          <header className="kf-header">
            <h2 id="kf-why-heading">Why kitchen fitters choose SnapScrap</h2>
            <p>Clear space, keep jobs moving, and handle metal the responsible way</p>
          </header>

          <ul className="kf-why-grid">
            {REASONS.map((item) => (
              <li key={item.title}>
                <h3>{item.title}</h3>
                <p>{item.body}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="kf-cta" aria-label="Post scrap call to action">
        <div className="kf-cta-inner">
          <div className="kf-cta-copy">
            <h2>Post your kitchen scrap for free today</h2>
            <p>List leftovers from your next fit-out and get matched with a licensed collector.</p>
          </div>
          <Link className="kf-btn kf-btn-light" to="/post-scrap">
            Post scrap free →
          </Link>
        </div>
      </section>
    </div>
  );
}
